import React from "react";
import { NavLink } from "react-router-dom";
class SubmitPage extends React.Component {
  render() {
    return (
      <div className="final-message text-center">
        <h3 className="p-3 mb-2">
          Thanks for Providing your Details
        </h3>
        <h5>CDK will contact you back soon!</h5>
        <p>
          Click here to {" "}
          <NavLink to="/" activeClassName="text-decoration-none">
            Sign Out
          </NavLink>
          .
        </p>
      </div>
    );
  }
}

export default SubmitPage;
